// extracted by mini-css-extract-plugin
export default {"heading":"heading--dYg_N","divider":"divider--_ESMc","paperBox":"paperBox--Niham","group":"group--_IZmd"};